module.exports = __webpack_public_path__ + "img/homePage.2019d930.jpg";